// extracted by mini-css-extract-plugin
export var locationCard = "_dk-0";